window.addEventListener('load', () => {
  // Update shipping rates block in cart
  updateShippingRatesCartSection();

  // Update product schema with aggregate rating from Areviews app
  updateProductSchemaWithAggregateRating();

  // For Live Chat button at Contact Us page
  showLiveChatOnlineLabel();

  // Adjust header position under announcement bar if its Sticky option is enabled
  let timeout = false, // holder for timeout id
  delay = 250; // delay after event is "complete" to run callback
  setAnnouncementBarSticky('.sticky-announcement-bar-before-page-load');
  window.addEventListener('resize', event => {
    clearTimeout(timeout);
    timeout = setTimeout(setAnnouncementBarSticky, delay);
  });

});


const updateProductSchemaWithAggregateRating = async () => {
  let ratingValueElement  = await waitForElement('.average_rating .box_rating4_average', '#az_reviews'),
    ratingCountElement    = await waitForElement('.main_review_stars > div', '#az_reviews'),
    ratingValue           = ratingValueElement?.textContent,
    ratingCount           = ratingCountElement?.textContent?.match(/(\d+)/)?.[0] || 0,
    productSchemaScript   = document.querySelector('.section-main-product > script[type="application/json"]');

  if (ratingValue == '0.0') ratingValue = 0;

  if (ratingValue == undefined || productSchemaScript == null) return;

  let productSchemaJson = JSON.parse(productSchemaScript.textContent);

  productSchemaJson['aggregateRating'] = {
    "@type": "AggregateRating",
    "ratingValue": ratingValue,
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": ratingCount
  };

  productSchemaScript.innerHTML = JSON.stringify(productSchemaJson);

}

function waitForElement(selector, parentWrapperSelector = 'body') {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      const parentWrapper = document.querySelector(parentWrapperSelector) || document.body;
      observer.observe(parentWrapper, {
          childList: true,
          subtree: true
      });
  });
}

const updateShippingRatesCartSection = () => {
  let shippingRatesWrapper    = document?.querySelector('.cbb-shipping-rates-calculator'),
    checkoutNoteWrapper       = document?.querySelector('.checkout-note'),
    shippingPricesWrapper     = shippingRatesWrapper?.querySelector('.cbb-shipping-rates-calculator-totals'),
    checkoutSubtotalWrapper   = document?.querySelector('.checkout-subtotal-container__right__main'),
    checkoutSubtotalTitle     = checkoutSubtotalWrapper?.querySelector('.subtotal'),
    continueShoppingButton    = checkoutSubtotalWrapper?.querySelector('.continue-shopping'),
    checkoutSubmitButton      = checkoutSubtotalWrapper?.querySelector('button[type=submit]#update-cart'),
    additionalCheckoutButtons = checkoutSubtotalWrapper?.querySelector('.additional-checkout-buttons');

  checkoutNoteWrapper?.before(shippingRatesWrapper);
  checkoutSubtotalTitle?.after(shippingPricesWrapper);
  checkoutSubmitButton?.after(continueShoppingButton);
  checkoutSubtotalWrapper?.after(additionalCheckoutButtons);

  checkoutNoteWrapper?.style ? checkoutNoteWrapper.style.opacity = 1 : '';
  continueShoppingButton?.style ? continueShoppingButton.style.opacity = 1 : '';
  checkoutSubtotalTitle?.style ? checkoutSubtotalTitle.style.marginBottom = '30px' : '';
  continueShoppingButton?.classList.add('button', 'button--large');
}

const showLiveChatOnlineLabel = () => {
  let onlineLabel = document.querySelector('.contact-live-chat--online-label');
  if (!onlineLabel) return;
  waitForElement('#chatra__iframe').then(() => {
    onlineLabel.classList.remove('hidden');
  });

}

var blogPost = document.querySelector( '.add-klaviyo-form' );

if( null != blogPost ){
  var article = blogPost.querySelector( '.rte' ),
      p = article.querySelectorAll( 'p' ),
      klaviyoDiv = document.createElement( 'div' );

      klaviyoDiv.classList.add( 'klaviyo-form-T6kNzY' );
      klaviyoDiv.classList.add( 'spaced-row' );

      article.after( klaviyoDiv );
}

function setAnnouncementBarSticky(elementClass = 'sticky-announcement-bar') {
  elementClass = elementClass.replace('.', '');
  let stickyAnnouncementBar = document.querySelector('.' + elementClass),
  stickyAnnouncementBarWrapper = document.querySelector('#shopify-section-announcement-bar');

  if (stickyAnnouncementBar) {
    let headerNavigation = document.querySelector('#shopify-section-header');

    if (headerNavigation){
      stickyAnnouncementBar.classList.replace(elementClass, 'sticky-announcement-bar');

      if (stickyAnnouncementBarWrapper) stickyAnnouncementBarWrapper.style.height = stickyAnnouncementBar.offsetHeight + 'px';
      headerNavigation.style.top = stickyAnnouncementBar.offsetHeight + 'px';
    }
  }
}
